<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('课程id')" prop="courseId">
                <a-input v-model="queryParam.courseId" @pressEnter="handleQuery" :placeholder="$t('请输入')+$t('课程id')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('订单状态')" prop="orderStatus">
                <a-select v-model="queryParam.orderStatus" :placeholder="$t('请选择')+$t('订单状态')" allow-clear>
                  <a-select-option :value="10">{{ $t('待付款') }}</a-select-option>
                  <a-select-option :value="20">{{ $t('已付款') }}</a-select-option>
                  <a-select-option :value="30">{{ $t('已取消') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 详情抽屉 -->
      <a-drawer width="480" :visible="detailVisible" @close="detailVisible = false">
        <a-divider orientation="left"><b>{{ $t('课程订单详情') }}</b></a-divider>
        <a-descriptions :column="1" bordered size="small" v-if="detail">
          <a-descriptions-item :label="$t('订单号')">{{ detail.orderNo }}</a-descriptions-item>
          <a-descriptions-item :label="$t('用户id')">{{ detail.userId }}</a-descriptions-item>
          <a-descriptions-item :label="$t('课程标题')">{{ detail.courseTitle }}</a-descriptions-item>
          <a-descriptions-item :label="$t('支付金额')">{{ detail.payAmount }}</a-descriptions-item>
          <a-descriptions-item :label="$t('订单状态')">{{ detail.orderStatusName }}</a-descriptions-item>
          <a-descriptions-item :label="$t('支付时间')">{{ parseTime(detail.payTime) }}</a-descriptions-item>
          <a-descriptions-item :label="$t('创建时间')">{{ parseTime(detail.createTime) }}</a-descriptions-item>
        </a-descriptions>
      </a-drawer>
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: 1200 }"
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="payTime" slot-scope="text, record">
          {{ parseTime(record.payTime) }}
        </span>
        <span slot="orderStatus" slot-scope="text, record">
          <a-tag :color="statusColor(record.orderStatus)">{{ record.orderStatusName }}</a-tag>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDetail(record)"><a-icon type="eye" />{{$t('详情')}}</a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageEduCourseOrder, getEduCourseOrder } from '@/api/edu/courseOrder'
import { mapGetters } from 'vuex'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'EduCourseOrder',
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      detailVisible: false,
      detail: null,
      loading: false,
      total: 0,
      queryParam: {
        courseId: null,
        orderStatus: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('订单号'),
          dataIndex: 'orderNo',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户id'),
          dataIndex: 'userId',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('课程标题'),
          dataIndex: 'courseTitle',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('支付金额'),
          dataIndex: 'payAmount',
          align: 'center'
        },
        {
          title: this.$t('订单状态'),
          dataIndex: 'orderStatus',
          scopedSlots: { customRender: 'orderStatus' },
          align: 'center'
        },
        {
          title: this.$t('支付时间'),
          dataIndex: 'payTime',
          scopedSlots: { customRender: 'payTime' },
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '10%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    statusColor(status) {
      switch (status) {
        case 10: return 'orange'
        case 20: return 'green'
        case 30: return 'red'
        default: return 'default'
      }
    },
    /** 查询课程订单列表 */
    getList () {
      this.loading = true
      pageEduCourseOrder(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleDetail (record) {
      getEduCourseOrder({ "id": record.id }).then(response => {
        this.detail = response.data
        this.detailVisible = true
      })
    },
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery () {
      this.queryParam = {
        courseId: undefined,
        orderStatus: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    }
  }
}
</script>
